export default {
  'cs-preloader-overlay': require('./new/PreloaderOverlay/PreloaderOverlay.vue').default,
  'cs-button': require('./new/Button/Button').default,
};
